import { useMemo } from 'react';

import { Pane, PaneHeader, PaneTitle, PaneBody } from '../components/pane';
import { UnderConstruction } from './UnderConstruction';

const InternalQuotesTable = () => {
  return (
    <UnderConstruction>
      We&apos;re working on a view of internal quote dependencies.
    </UnderConstruction>
  );
};

export type InternalQuotesPaneProps = {
  activeGroupIds: number[];
};

export const InternalQuotesPane = ({
  activeGroupIds,
}: InternalQuotesPaneProps) => {
  const websocketOptions = useMemo(() => {
    return {
      topic: activeGroupIds.map((id) => `${id}.quotes.created`),
    };
  }, [activeGroupIds]);

  return (
    <Pane refetchQueryKey="" websocketOptions={websocketOptions}>
      <PaneHeader>
        <PaneTitle>Internal Quotes</PaneTitle>
        {/* <PaneSubtitle>Created in the last 90 days</PaneSubtitle> */}
      </PaneHeader>
      <PaneBody>
        <InternalQuotesTable />
      </PaneBody>
    </Pane>
  );
};
